import {mutationHdl, queryHdl} from '../graphqlHdr';
import QueryExclusiveRoom from './queryExclusiveRoom.gql';
import QueryExclusiveLocation from './queryExclusiveLocation.gql';

export default {
  // queryAll: (vueSelf, variables) => queryHdl.call(vueSelf, QueryAll, variables),
  // 查询专属会议室列表
  queryExclusiveRoom: (vueSelf, variables) => queryHdl.call(vueSelf, QueryExclusiveRoom, variables),
  // 查询专属区域列表
  queryExclusiveLocation: (vueSelf, variables) => queryHdl.call(vueSelf, QueryExclusiveLocation, variables)
}
